// Parse a batting SKU's square-foot coverage from the "(N SF/bag)" pattern in
// its name. This is the JS mirror of the SQL backfill in migration
// 0060_sku_coverage_sf.sql — keep the two regexes in sync. Used by the Inventory
// SKU editor to auto-suggest coverage_sf when a batting SKU is saved without it
// (so new batts can't silently contribute 0 SF to insulation labor).
//
// Anchored on the "SF/bag" unit token, NOT end-of-string, so trailing text like
// "(106.67 SF/bag) SC" still matches and "(42 BAGS/unit)" does not.
const COVERAGE_SF_RE = /\(\s*(\d+(?:\.\d+)?)\s*SF\/bag/i;

/** Returns the parsed SF/bag, or null if the name has no "(N SF/bag)" token. */
export function parseCoverageSfFromName(name: string | null | undefined): number | null {
  if (!name) return null;
  const m = COVERAGE_SF_RE.exec(name);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) ? n : null;
}
